import classNames from 'classnames';
import React from 'react';
import { IconButton } from '../components/Button';
import clearIcon from '../icons/non-prefilled/16x16/clear.svg';
import * as styles from './Banner.module.scss';

interface BannerProps {
  children: React.ReactNode;
  onDismiss?: () => void;
  variant: 'inverted' | 'warning' | 'danger';
}

const Banner = ({ children, onDismiss, variant }: BannerProps) => (
  <div className={classNames(styles.container, styles[variant])}>
    <div className={styles.message}>{children}</div>
    {onDismiss && (
      <div className={styles.dismissContainer}>
        <IconButton aria-label="Dismiss" block onClick={onDismiss} size="xs">
          {clearIcon}
        </IconButton>
      </div>
    )}
  </div>
);

export default Banner;
